// extracted by mini-css-extract-plugin
export default {"container":"styles_container__-ffVu","header":"styles_header__D4HHE","amount":"styles_amount__0+ZZD","content":"styles_content__kjXmk","item":"styles_item__nCzF4"};